import { ToastService } from "@shared/lib/services";
import { IPayment } from "@shared/lib/types/briefCampains";
import { getBankVerificationLink } from "@shared/lib/utils/getBankVerificationLink";
import { Copy } from "lucide-react";
import styles from "./styles.module.scss";

type PayoutVerificationLinkProps = {
  record: IPayment;
};

export function PayoutVerificationLink({
  record,
}: PayoutVerificationLinkProps) {
  const verificationLink = getBankVerificationLink(record);
  if (!verificationLink) {
    return null;
  }

  return (
    <div className={styles.payoutVerification}>
      <a
        href={verificationLink}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.payoutVerificationLink}
      >
        Bank verification
      </a>
      <button
        type="button"
        className={styles.payoutCopyButton}
        aria-label="Copy bank verification link"
        onClick={() => {
          navigator.clipboard.writeText(verificationLink);
          ToastService.success("Link copied to clipboard");
        }}
      >
        <Copy size={12} />
      </button>
    </div>
  );
}
